<script setup lang="ts">

import { computed } from 'vue';
import { usePresentation } from '@/modules/Presentation/Types';
import { useLead } from "../../Types/Lead";
import { useForm, Form } from "@library/Components/Forms/Form/v2";
import { LeadOptions, Dojo } from '../../Types/LeadOptions';

import SelectOption from "../../Components/SelectOption.vue";
import VideoPushUp from '../../Components/VideoPushUp.vue';
import { Map } from '../../Types/Map';

const lead = useLead();
const form = await useForm( lead );
const presentation = usePresentation();
presentation.backgroundImage = '/images/sample/gkr-watermark.png';

presentation.canProceed = () => lead.dojo != null;
presentation.onSetNext = () => ({ section: Map.HowCanWeHelp, page: 0 });

const media = computed( () => 
{

    let media = { 
        title: "Great choice! Let’s keep going.",
        video: null as any,
        timetable: null as any
    };

    if( lead.dojo == null ) return media;
    
    switch( lead.dojo ) 
    {
        case Dojo.albionParkRail: media = { 
                title: "That's a great dojo, one of the best in the area. Lets take a look!",
                video: '~/video/gkr/self-defence.mov',
                timetable: '/images/sample/Dojo/timetable-wollongong.jpg'
            }
            break;

        case Dojo.bomaderry: media = { 
                title: "That's a great dojo, one of the best in the area. Lets take a look!",
                video: '~/video/gkr/gkr-r17-wollongong.mp4',
                timetable: '/images/sample/Dojo/timetable-wollongong.jpg'
            }
            break;

        case Dojo.mittagong: media = { 
                title: "That's a great dojo, one of the best in the area. Lets take a look!",
                video: '~/video/gkr/self-confidence.mov',
                timetable: '/images/sample/Dojo/timetable-wollongong.jpg'
            }
            break;

        case Dojo.mossVale: media = { 
                title: "That's a great dojo, one of the best in the area. Lets take a look!",
                video: '~/video/gkr/gkr-r17-mossvale.mp4',
                timetable: '/images/sample/Dojo/timetable-wollongong.jpg'
            }
            break;

        case Dojo.vincentia: media = { 
                title: "That's a great dojo, one of the best in the area. Lets take a look!",
                video: '~/video/gkr/gkr-r17-wollongong.mp4',
                timetable: '/images/sample/Dojo/timetable-wollongong.jpg'
            }
            break;
        
        case Dojo.wollongong: media = { 
                title: "That's a great dojo, one of the best in the area. Lets take a look!",
                video: '~/video/gkr/gkr-r17-wollongong.mp4',
                timetable: '/images/sample/Dojo/timetable-wollongong.jpg'
            }
            break;
    }

    if( media.video == null )
    {
        media.video = '~/video/gkr/gkr-r17-wollongong.mp4';
        media.timetable = '/images/sample/Dojo/timetable-wollongong.jpg';
    }

    return media;

});

</script>

<template>

    <Page>
    
        <ImageAndText 
            :src="`/Dojo/dojo.jpg`" 
            floor-shadow 
            border
            flip>
            
            <div class="tracking-wider">
                <h1 class="text-xl mt-3">
                    What suburb are you from, where do you live?
                </h1>
                <h1 class="text-lg font-normal mt-1">
                    GKR has training dojo's all over the region!
                </h1>
            </div>

            <Form 
                :form="form"
                v-slot="{ model, state }"
                class="flex flex-col gap-4 mb-4">

                <h1 class="mt-6">Which Dojo is best for you?</h1>

                <SelectOption 
                    v-model="model.dojo" 
                    :options="LeadOptions.dojo"               
                />

            </Form>

        </ImageAndText>

        <Transition name="push-up" :duration="300" mode="out-in">
            
            <VideoPushUp 
                v-if="lead.dojo != null"
                :title="media.title"
                :video-src="media.video"
                class="-mx-20">

                <button 
                    v-if="false"
                    class="flex gap-4 justify-center items-center px-6 z-50
                        rounded-full bg-white/10 hover:bg-white/[15%] shadow"
                    @click="() => presentation.displayMedia( media.timetable )">

                    <div class="rounded-full ring-[7px] ring-gray-900/50">
                        <div class="
                            rounded-full w-16 h-16 ring-4 ring-gray-200 text-gray-200 flex items-center justify-center
                            transition-all duration-150
                            bg-white/10 shadow-xl">
                            <div class="absolute bottom-0 left-0 w-full h-1/2 rounded-b-full bg-gradient-to-b from-white/5 via-30% via-transparent to-transparent" />
                            <Icon name="calendar" />
                        </div>
                    </div>

                    <div class="tracking-wider flex text-center font-semibold uppercase">Class Timetable</div>

                </button>

            </VideoPushUp>

        </Transition>   

    </Page>

</template>